import { render, staticRenderFns } from "./PublisherProfilePanel.vue?vue&type=template&id=5cd45717&scoped=true&"
import script from "./PublisherProfilePanel.vue?vue&type=script&lang=js&"
export * from "./PublisherProfilePanel.vue?vue&type=script&lang=js&"
import style0 from "./PublisherProfilePanel.vue?vue&type=style&index=0&id=5cd45717&prod&scoped=true&lang=css&"
import style1 from "./PublisherProfilePanel.vue?vue&type=style&index=1&id=5cd45717&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd45717",
  null
  
)

export default component.exports